import { createTheme } from './createTheme';
import { ITheme } from './types/ITheme';

export const FluentTheme: ITheme = createTheme({});
